import React from 'react';
import './NewMainPage.css';
import BackgroundContainer from '../components/BackgroundContainer';
import MenuButton from '../components/MenuButton';
import BaseButton from '../components/BaseButton';
import BaseHeader from '../components/BaseHeader';
import { useNavigate } from 'react-router-dom';
import InstallGuide from '../components/InstallGuide';
import { Helmet } from 'react-helmet';


function NewMainPage() {
  const navigate = useNavigate();
  return (
      <>
      <Helmet>
        <title>Deeper – Intimacy Game for Couples</title>
        <meta name="description" content="Turn date night into a sexual journey. A couples game blending intimacy, tantra, and daring prompts that unlock connection, pleasure, and trust." />
        <meta name="keywords" content="deeper, truth or dare, couples game, intimacy, couples intimate game, romantic game, tantra, tantric game, bonding game, couples date game" />
        <meta name="google-site-verification" content="sFezuRqIVh8SsG0d_xxitHlu4qi28wIlscHsOGv_kIo" />
        <link rel="canonical" href="https://deepergm.com/" />

        {/* Open Graph for social sharing */}
        <meta property="og:title" content="Deeper – Intimacy Game for Couples" />
        <meta property="og:description" content="Turn date night into a sexual journey. A couples game blending intimacy, tantra, and daring prompts that unlock connection, pleasure, and trust." />
        <meta property="og:image" content="https://deepergm.com/deeperpreview.jpg" />
        <meta property="og:url" content="https://deepergm.com/" />
        <meta property="og:type" content="website" />
      </Helmet>
    <BackgroundContainer sx={{paddingBottom:'80px', overflowY:'hidden'}}>
        <MenuButton
          showLogin={true}
          showAccount={true}
          faq={true}
          showQuitApp={true}
          showDownload={true}
        />
        <div className="menu-container">
          <BaseHeader>Deeper</BaseHeader>
          {/* <h1 className="menu-title">Deeper</h1> */}
          {/* <p className="menu-subtitle">Explore each other, one question at a time.</p> */}
          <p className="menu-subtitle">Explore yourselves, one question at a time.</p>

          <div className="menu-buttons">
          <BaseButton sx={{minWidth: '65%',}} icon={'▶︎'} onClick={() => navigate("/contestants")}>
            PLAY
          </BaseButton>
          <BaseButton sx={{minWidth: '65%',}} icon={'📋'} onClick={() => navigate("/rules")}>
            Rules
          </BaseButton>
          <BaseButton sx={{minWidth: '65%',}} icon={'ⓘ'} onClick={() => navigate("/about")}>
            About
          </BaseButton>
          <InstallGuide/>

          </div>
        
    </div>
    </BackgroundContainer>
    </>
  );
}

export default NewMainPage;
